module.exports = __webpack_public_path__ + "assets/img/TLSC3-2.c5525386.png";